import React from 'react';

import { AceiteDePagamento } from '~/pages/AceitePagamento';
import AjusteDeEstoque from '~/pages/AjusteDeEstoque';
import AjusteMargemProduto from '~/pages/AjusteMargemProduto';
import { AlteracaoCustoNfBonificada } from '~/pages/AlteracaoDeCustoPorNFBonificada';
import AlteracaoDePreco from '~/pages/AlteracaoDePreco';
import AlteracaoPrecoEntradaFornecedor from '~/pages/AlteracaoPrecoEntradaFornecedor';
import CadastroDeAplicacao from '~/pages/CadastroDeAplicacao';
import CadastroDeBanco from '~/pages/CadastroDeBanco';
import CadastroDeCondicao from '~/pages/CadastroDeCondicao';
import CadastroDeDecomposicao from '~/pages/CadastroDeDecomposicao';
import CadastroDeInterface from '~/pages/CadastroDeInterface';
import CadastroDeTela from '~/pages/CadastroDeTela';
import CadastroDeTransportadora from '~/pages/CadastroDeTransportadora';
import CadastroGrupoAplicacao from '~/pages/CadastroGrupoAplicacao';
import CadastroStatusPdv from '~/pages/CadastroStatusPDV';
import CancelamentoDeNota from '~/pages/CancelamentoDeNota';
import Carga from '~/pages/Carga';
import CatalogoNcm from '~/pages/CatalogoDeNcm';
import CategoriaFinanceira from '~/pages/CategoriaFinanceira';
import CentralDeLiberacaoDeTerminais from '~/pages/CentralDeLiberacaoDeTerminais';
import CentralDeNotificacao from '~/pages/CentralDeNotificacoes';
import Cest from '~/pages/Cest';
import Cfop from '~/pages/Cfop';
import CheckList from '~/pages/CheckList';
import Cidade from '~/pages/Cidade';
import ClassificacaoParceiro from '~/pages/ClassificacaoParceiro';
import Cliente from '~/pages/Cliente';
import { ConferenciaTesouraria } from '~/pages/ConferenciaTesouraria';
import ConfiguracaoDeEmail from '~/pages/ConfiguracaoDeEmail';
import ContaBancaria from '~/pages/ContaBancaria';
import ContasAPagar from '~/pages/ContasAPagar';
import ContasAReceber from '~/pages/ContasAReceber';
import ControleDeAcesso from '~/pages/ControleDeAcesso';
import Dashboard from '~/pages/Dashboard';
import Departamento from '~/pages/Departamento';
import { DevolucaoESaidaNfForn } from '~/pages/DevolucaoESaidaNFDeFornecedor';
import EdicaoDeConta from '~/pages/EdicaoDeConta';
import { EmissaoNFE } from '~/pages/EmissaoNFE';
import { EntradaNFE } from '~/pages/EntradaNFE';
import Feriados from '~/pages/Feriados';
import Finalizadora from '~/pages/Finalizadora';
import Fornecedor from '~/pages/Fornecedor';
import GrupoDeEmpresa from '~/pages/GrupoDeEmpresa';
import GrupoDeEtiqueta from '~/pages/GrupoDeEtiqueta';
import InformacaoNutricional from '~/pages/InformacaoNutricional';
import InutilizacaoNfe from '~/pages/InutilizacaoNfe';
import LancamentoCaixa from '~/pages/LancamentoNoCaixa';
import LiberacaoDeToken from '~/pages/LiberacaoDeToken';
import Loja from '~/pages/Loja';
import { ManutencaoFiscal } from '~/pages/ManutencaoFiscal';
import { Marcas } from '~/pages/Marcas';
import Mix from '~/pages/Mix';
import ModeloDeEtiqueta from '~/pages/ModeloDeEtiqueta';
import { Modulo } from '~/pages/Modulo';
import { MonitorApi } from '~/pages/MonitorApi';
import MonitorXml from '~/pages/MonitorXml';
import Ncm from '~/pages/Ncm';
import { NFOutrasOperacoes } from '~/pages/NFOutrasOperacoes';
import Operador from '~/pages/Operador';
import CadastroPais from '~/pages/Pais';
import ParametrizacaoNfe from '~/pages/ParametrizacaoNfe';
import CadastroPauta from '~/pages/Pauta';
import Pdv from '~/pages/Pdv';
import PdvOnline from '~/pages/PdvOnline';
import PerfilDeDocumentos from '~/pages/PerfilDeDocumentos';
import ProcessamentoManualXml from '~/pages/ProcessamentoManualXml';
import { Produto } from '~/pages/Produto';
import ProgramacaoOferta from '~/pages/ProgramacaoOferta';
import QuitacaoEmLote from '~/pages/QuitacaoEmLote';
import CadastroReceita from '~/pages/Receita';
import RegraDeEmpresa from '~/pages/RegraDeEmpresa';
import RegraDeLoja from '~/pages/RegraDeLoja/RegraLojaContent';
import RelatorioDeVendas from '~/pages/RelatorioDeVendas';
import RelatorioEntradaNFE from '~/pages/RelatorioEntradaNFE';
import RelatorioLogsCargas from '~/pages/RelatorioLogsCarga';
import RelatorioSaidaNFE from '~/pages/RelatorioSaidaNFE';
import RetencoesTributarias from '~/pages/RetencoesTributarias';
import SerieNF from '~/pages/SerieNF';
import Similar from '~/pages/Similar';
import TabelaDePreco from '~/pages/TabelaDePreco';
import Tara from '~/pages/Tara';
import TesteComponente from '~/pages/TesteComponente';
import TipoAjusteEstoque from '~/pages/TipoAjusteEstoque';
import TipoDeDados from '~/pages/TipoDeDados';
import TipoDeInformacoes from '~/pages/TipoDeInformacoes';
import TipoDeMovimentoDeCaixa from '~/pages/TipoDeMovimentoDeCaixa';
import TipoItem from '~/pages/TipoItem';
import Tributacao from '~/pages/Tributacao';
import Usuario from '~/pages/Usuario';
import { ValidadorXML } from '~/pages/ValidadorXML';
import VincularEmail from '~/pages/VincularEmail';
import { LiberacaoTesouraria } from '~/pages/LiberacaoTesouraria';
import ExportacaoEscritaFiscal from '~/pages/ExportacaoEscritaFiscal';
import SpedFiscal from '~/pages/SpedFiscal';
import { GuiaInformacaoApuracaoIcms } from '~/pages/GuiaInformacaoApuracaoIcms';
import Unidade from '~/pages/Unidade';
import SpedContribuicoes from '~/pages/SpedContribuicoes';
import { ConferenciaDeVendas } from '~/pages/ConferenciaDeVendas';
import { AlteracaoDePrecoPorItem } from '~/pages/AlteracaoDePrecoPorItem';
import RelatorioAuditoriaUsuario from '~/pages/RelatorioAuditoriaUsuario';
import { CadastroDeInformacaoComplementar } from '~/pages/CadastroDeInformacaoComplementar';
import { FechamentoFiscal } from '~/pages/FechamentoFiscal';
import ReprocessaPisCofins from '~/pages/ReprocessaPisCofins';
import { ApuracaoDePisCofins } from '~/pages/ApuracaoDePisCofins';
import RelatorioVendasPorDia from '~/pages/RelatorioVendasPorDia';
import { RegistroDeInventario } from '~/pages/RegistroDeInventario';
import ImpressaoDeEtiquetas from '~/pages/ImpressaoDeEtiquetas';
import { ApuracaoIcms } from '~/pages/ApuracaoIcms';
import RelatorioDiferencaLancamentos from '~/pages/RelatorioDiferencaLancamentos';
import { IdentificacaoContabil } from '~/pages/IdentificacaoContabil';
import { Trilha } from '~/pages/Trilha';
import { PedidoVenda } from '~/pages/PedidoVenda';
import PlanoContratacao from '~/pages/PlanoContratacao';
import GradeDeProduto from '~/pages/Grade';
import { MeuPlano } from '~/pages/MeuPlano';
import RelatorioRaioXVendas from '~/pages/RelatorioRaioXVendas';
import ManutencaoFiscalNfce from '~/pages/ManutencaoFiscalNFCE';
import CadastroComposicao from '~/pages/CadastroDeComposicao';
import { CadastroProducao } from '~/pages/CadastroDePoducao';
import { AgendamentoDeContas } from '~/pages/AgendamentoDeContas';
import { FluxoDeCaixa } from '~/pages/FluxoDeCaixa';
import { CadastroAdministradora } from '~/pages/CadastroDeAdministradora';
import { ClassificacaoIbsCbs } from '~/pages/ClassificacaoDeIbsCbs';
import { MovimentoDeProducao } from '~/pages/MovimentoDeProducao';
import HabitoDeConsumo from '~/pages/HabitoDeConsumo';
import { AlteracaoIbsCbsEmLote } from '~/pages/AlteracaoIbsCbsEmLote';
import { TransferenciaDePOS } from '~/pages/TransferenciaDePOS';
import { AjusteDePara } from '~/pages/AjusteDePara';
import { RelatorioDeConferenciaDeEntrada } from '~/pages/RelatorioDeConferenciaDeEntrada';
import { RomaneioDeFornecedor } from '~/pages/RomaneioDeFornecedor';
import { AlteracaoNcmEmLote } from '~/pages/AlteracaoNcmEmLote';

export type MenuItem = Readonly<{
  id: number;
  url: string;
  content: React.ElementType;
}>;

export const createMenuItem = (item: MenuItem): MenuItem => item;

const warnDuplicates = (items: MenuItem[]): void => {
  const idCount = new Map<number, number>();
  const urlCount = new Map<string, number>();

  items.forEach((item) => {
    idCount.set(item.id, (idCount.get(item.id) ?? 0) + 1);
    urlCount.set(item.url, (urlCount.get(item.url) ?? 0) + 1);
  });

  const duplicatedIds = [...idCount.entries()].filter(([, c]) => c > 1);
  const duplicatedUrls = [...urlCount.entries()].filter(([, c]) => c > 1);

  if (duplicatedIds.length) {
    console.warn(
      '[itemsMenu] IDs duplicados:',
      duplicatedIds.map(([id, c]) => `${id} (x${c})`).join(', '),
    );
  }

  if (duplicatedUrls.length) {
    console.warn(
      '[itemsMenu] URLs duplicadas:',
      duplicatedUrls.map(([url, c]) => `${url} (x${c})`).join(', '),
    );
  }
};

const itemsMenu: MenuItem[] = [
  createMenuItem({
    id: 1,
    url: 'controle-de-acesso',
    content: ControleDeAcesso,
  }),
  createMenuItem({ id: 2, url: 'usuario', content: Usuario }),
  createMenuItem({ id: 3, url: 'loja', content: Loja }),
  createMenuItem({ id: 11, url: 'pdv', content: Pdv }),
  createMenuItem({ id: 12, url: 'tributacao', content: Tributacao }),
  createMenuItem({ id: 14, url: 'operador-de-caixa', content: Operador }),
  createMenuItem({ id: 15, url: 'serie-de-nf', content: SerieNF }),
  createMenuItem({ id: 16, url: 'cest', content: Cest }),
  createMenuItem({ id: 18, url: 'componente', content: TesteComponente }),
  createMenuItem({ id: 19, url: 'ncm', content: Ncm }),
  createMenuItem({ id: 20, url: 'departamento', content: Departamento }),
  createMenuItem({ id: 21, url: 'cliente', content: Cliente }),
  createMenuItem({
    id: 22,
    url: 'tipo-de-ajuste-de-estoque',
    content: TipoAjusteEstoque,
  }),
  createMenuItem({ id: 23, url: 'grupo-de-empresa', content: GrupoDeEmpresa }),
  createMenuItem({ id: 24, url: 'fornecedor', content: Fornecedor }),
  createMenuItem({ id: 25, url: 'regras-de-loja', content: RegraDeLoja }),
  createMenuItem({ id: 26, url: 'regras-de-empresa', content: RegraDeEmpresa }),
  createMenuItem({ id: 27, url: 'tabela-de-precos', content: TabelaDePreco }),
  createMenuItem({ id: 28, url: 'produto', content: Produto }),
  createMenuItem({ id: 29, url: 'similares', content: Similar }),
  createMenuItem({
    id: 30,
    url: 'ajuste-de-estoque',
    content: AjusteDeEstoque,
  }),
  createMenuItem({ id: 31, url: 'check-list', content: CheckList }),
  createMenuItem({ id: 32, url: 'mix-de-produto', content: Mix }),
  createMenuItem({ id: 33, url: 'tara', content: Tara }),
  createMenuItem({
    id: 37,
    url: 'alteracao-de-preco',
    content: AlteracaoDePreco,
  }),
  createMenuItem({
    id: 35,
    url: 'informacao-nutricional',
    content: InformacaoNutricional,
  }),
  createMenuItem({
    id: 34,
    url: 'categoria-financeira',
    content: CategoriaFinanceira,
  }),
  createMenuItem({ id: 36, url: 'receita', content: CadastroReceita }),
  createMenuItem({ id: 39, url: 'finalizadora', content: Finalizadora }),
  createMenuItem({ id: 40, url: 'conta-bancaria', content: ContaBancaria }),
  createMenuItem({
    id: 41,
    url: 'certificado-digital',
    content: ParametrizacaoNfe,
  }),
  createMenuItem({ id: 47, url: 'emissao-nfe', content: EmissaoNFE }),
  createMenuItem({
    id: 50,
    url: 'configuracao-de-e-mail',
    content: ConfiguracaoDeEmail,
  }),
  createMenuItem({
    id: 45,
    url: 'programacao-de-oferta',
    content: ProgramacaoOferta,
  }),
  createMenuItem({ id: 44, url: 'carga', content: Carga }),
  createMenuItem({ id: 46, url: 'contas-a-receber', content: ContasAReceber }),
  createMenuItem({ id: 52, url: 'vincular-email', content: VincularEmail }),
  createMenuItem({ id: 49, url: 'feriado', content: Feriados }),
  createMenuItem({ id: 51, url: 'contas-a-pagar', content: ContasAPagar }),
  createMenuItem({ id: 54, url: 'cidade', content: Cidade }),
  createMenuItem({ id: 55, url: 'quitacao-em-lote', content: QuitacaoEmLote }),
  createMenuItem({
    id: 57,
    url: 'perfil-de-documentos',
    content: PerfilDeDocumentos,
  }),
  createMenuItem({ id: 58, url: 'validador-de-xml', content: ValidadorXML }),
  createMenuItem({ id: 60, url: 'entrada-de-nfe', content: EntradaNFE }),
  createMenuItem({
    id: 61,
    url: 'monitor-de-recepcao-de-xmls',
    content: MonitorXml,
  }),
  createMenuItem({ id: 82, url: 'status-pdv', content: CadastroStatusPdv }),
  createMenuItem({
    id: 83,
    url: 'retencoes-tributarias',
    content: RetencoesTributarias,
  }),
  createMenuItem({
    id: 90,
    url: 'relatorio-de-logs-de-nfes-de-entrada',
    content: RelatorioEntradaNFE,
  }),
  createMenuItem({
    id: 91,
    url: 'relatorio-de-logs-de-nfes-de-saida',
    content: RelatorioSaidaNFE,
  }),
  createMenuItem({ id: 92, url: 'cfop', content: Cfop }),
  createMenuItem({ id: 93, url: 'pais', content: CadastroPais }),
  createMenuItem({
    id: 94,
    url: 'ajuste-margem-produto',
    content: AjusteMargemProduto,
  }),
  createMenuItem({ id: 127, content: CadastroPauta, url: 'pauta' }),
  createMenuItem({
    id: 170,
    url: 'relatorio-vendas',
    content: RelatorioDeVendas,
  }),
  createMenuItem({
    id: 174,
    content: RelatorioLogsCargas,
    url: 'relatorio-de-logs-de-cargas',
  }),
  createMenuItem({
    id: 172,
    content: NFOutrasOperacoes,
    url: 'lancamento-nf-de-outras-operacoes',
  }),
  createMenuItem({ id: 178, url: 'catalogo-ncm', content: CatalogoNcm }),
  createMenuItem({
    id: 175,
    url: 'classificacao-parceiro',
    content: ClassificacaoParceiro,
  }),
  createMenuItem({ id: 180, url: 'banco', content: CadastroDeBanco }),
  createMenuItem({ id: 179, url: 'tipo-de-dados', content: TipoDeDados }),
  createMenuItem({
    id: 173,
    content: AceiteDePagamento,
    url: 'aceite-de-pagamento',
  }),
  createMenuItem({ id: 181, url: 'tipo-item', content: TipoItem }),
  createMenuItem({ id: 186, url: 'condicao', content: CadastroDeCondicao }),
  createMenuItem({ id: 183, url: 'modulo', content: Modulo }),
  createMenuItem({ id: 193, url: 'grupo-etiqueta', content: GrupoDeEtiqueta }),
  createMenuItem({
    id: 194,
    url: 'grupo-de-aplicacao',
    content: CadastroGrupoAplicacao,
  }),
  createMenuItem({ id: 195, url: 'interface', content: CadastroDeInterface }),
  createMenuItem({
    id: 196,
    url: 'modelo-etiqueta',
    content: ModeloDeEtiqueta,
  }),
  createMenuItem({
    id: 198,
    url: 'processamento-manual-xml',
    content: ProcessamentoManualXml,
  }),
  createMenuItem({
    id: 202,
    url: 'central-de-liberacao-de-tokens',
    content: LiberacaoDeToken,
  }),
  createMenuItem({
    id: 197,
    url: 'tipo-informacao',
    content: TipoDeInformacoes,
  }),
  createMenuItem({ id: 201, url: 'aplicacao', content: CadastroDeAplicacao }),
  createMenuItem({ id: 204, url: 'app', content: Dashboard }),
  createMenuItem({
    id: 205,
    url: 'central-notificacao',
    content: CentralDeNotificacao,
  }),
  createMenuItem({
    id: 203,
    url: 'devolucao-e-saida-nf-forn',
    content: DevolucaoESaidaNfForn,
  }),
  createMenuItem({
    id: 206,
    url: 'central-de-liberação-de-terminais',
    content: CentralDeLiberacaoDeTerminais,
  }),
  createMenuItem({
    id: 208,
    url: 'transportadora',
    content: CadastroDeTransportadora,
  }),
  createMenuItem({
    id: 209,
    url: 'cadastro-de-decomposicao',
    content: CadastroDeDecomposicao,
  }),
  createMenuItem({
    id: 211,
    url: 'cancelamento-nf',
    content: CancelamentoDeNota,
  }),
  createMenuItem({
    id: 210,
    url: 'alteracao-precos-entrada-fornecedor',
    content: AlteracaoPrecoEntradaFornecedor,
  }),
  createMenuItem({ id: 222, url: 'cadastro-de-tela', content: CadastroDeTela }),
  createMenuItem({ id: 223, url: 'edicao-conta', content: EdicaoDeConta }),
  createMenuItem({
    id: 272,
    url: 'manutencao-fiscal',
    content: ManutencaoFiscal,
  }),
  createMenuItem({
    id: 213,
    url: 'alteracao-custo-entrada-nf-bonificada',
    content: AlteracaoCustoNfBonificada,
  }),
  createMenuItem({
    id: 275,
    url: 'lancamento-caixa',
    content: LancamentoCaixa,
  }),
  createMenuItem({
    id: 276,
    url: 'tipo-movimento',
    content: TipoDeMovimentoDeCaixa,
  }),
  createMenuItem({
    id: 277,
    url: 'conferencia-tesouraria',
    content: ConferenciaTesouraria,
  }),
  createMenuItem({
    id: 278,
    url: 'inutilizacao-nfe',
    content: InutilizacaoNfe,
  }),
  createMenuItem({
    id: 279,
    url: 'identificacao-contabil',
    content: IdentificacaoContabil,
  }),
  createMenuItem({ id: 281, url: 'marcas', content: Marcas }),
  createMenuItem({
    id: 280,
    url: 'liberacao-tesouraria',
    content: LiberacaoTesouraria,
  }),
  createMenuItem({
    id: 282,
    url: 'monitor-de-api-de-integracao',
    content: MonitorApi,
  }),
  createMenuItem({ id: 283, url: 'pdv-online', content: PdvOnline }),
  createMenuItem({
    id: 284,
    url: 'exportacao-escrita-fiscal',
    content: ExportacaoEscritaFiscal,
  }),
  createMenuItem({ id: 285, url: 'sped-fiscal', content: SpedFiscal }),
  createMenuItem({ id: 286, url: 'gia', content: GuiaInformacaoApuracaoIcms }),
  createMenuItem({ id: 287, url: 'unidade', content: Unidade }),
  createMenuItem({
    id: 288,
    url: 'sped-efd-contribuicoes',
    content: SpedContribuicoes,
  }),
  createMenuItem({
    id: 289,
    url: 'conferencia-venda-sat-nfce',
    content: ConferenciaDeVendas,
  }),
  createMenuItem({
    id: 290,
    url: 'alteracao-de-preco-por-item',
    content: AlteracaoDePrecoPorItem,
  }),
  createMenuItem({
    id: 291,
    url: 'relatorio-auditoria-usuarios',
    content: RelatorioAuditoriaUsuario,
  }),
  createMenuItem({
    id: 292,
    url: 'informacao-complementar',
    content: CadastroDeInformacaoComplementar,
  }),
  createMenuItem({
    id: 294,
    url: 'fechamento-fiscal',
    content: FechamentoFiscal,
  }),
  createMenuItem({
    id: 293,
    url: 'reprocessa-pis-cofins',
    content: ReprocessaPisCofins,
  }),
  createMenuItem({
    id: 295,
    url: 'apuracao-pis-cofins',
    content: ApuracaoDePisCofins,
  }),
  createMenuItem({
    id: 299,
    url: 'relatorio-vendas-por-dia',
    content: RelatorioVendasPorDia,
  }),
  createMenuItem({
    id: 297,
    url: 'registro-inventario',
    content: RegistroDeInventario,
  }),
  createMenuItem({
    id: 296,
    url: 'impressao-etiqueta',
    content: ImpressaoDeEtiquetas,
  }),
  createMenuItem({ id: 298, url: 'apuracao-icms', content: ApuracaoIcms }),
  createMenuItem({
    id: 300,
    url: 'relatorio-diferenca-lancamentos',
    content: RelatorioDiferencaLancamentos,
  }),
  createMenuItem({ id: 303, url: 'trilha', content: Trilha }),
  createMenuItem({ id: 302, url: 'pedido-venda', content: PedidoVenda }),
  createMenuItem({
    id: 304,
    url: 'plano-contratacao',
    content: PlanoContratacao,
  }),
  createMenuItem({ id: 306, url: 'grade-de-produto', content: GradeDeProduto }),
  createMenuItem({ id: 305, url: 'meu-plano', content: MeuPlano }),
  createMenuItem({
    id: 308,
    url: 'relatorio-raiox-vendas',
    content: RelatorioRaioXVendas,
  }),
  createMenuItem({
    id: 309,
    url: 'manutencao-fiscal-nfce',
    content: ManutencaoFiscalNfce,
  }),
  createMenuItem({ id: 312, url: 'composicao', content: CadastroComposicao }),
  createMenuItem({ id: 313, url: 'producao', content: CadastroProducao }),
  createMenuItem({
    id: 314,
    url: 'agendamento-de-contas',
    content: AgendamentoDeContas,
  }),
  createMenuItem({ id: 315, url: 'fluxo-de-caixa', content: FluxoDeCaixa }),
  createMenuItem({
    id: 316,
    url: 'administradora-cartoes',
    content: CadastroAdministradora,
  }),
  createMenuItem({
    id: 317,
    url: 'classificacao-ibs-cbs',
    content: ClassificacaoIbsCbs,
  }),
  createMenuItem({
    id: 319,
    url: 'movimento-producao',
    content: MovimentoDeProducao,
  }),
  createMenuItem({
    id: 321,
    url: 'analise-habito-consumo',
    content: HabitoDeConsumo,
  }),
  createMenuItem({
    id: 318,
    url: 'alteracao-ibs-cbs-em-lote',
    content: AlteracaoIbsCbsEmLote,
  }),
  createMenuItem({
    id: 320,
    url: 'transferencia-pos',
    content: TransferenciaDePOS,
  }),
  createMenuItem({ id: 322, url: 'ajuste-de-para', content: AjusteDePara }),
  createMenuItem({
    id: 324,
    url: 'relatorio-conferencia-entrada',
    content: RelatorioDeConferenciaDeEntrada,
  }),
  createMenuItem({
    id: 325,
    url: 'romaneio-fornecedor',
    content: RomaneioDeFornecedor,
  }),
  createMenuItem({
    id: 327,
    url: 'alteracao-ncm-em-lote',
    content: AlteracaoNcmEmLote,
  }),
  // PARA NOVAS TELAS UTILIZAR O COD_TELA 328 (ALTERADO NO BANCO)
];

if (process.env.NODE_ENV !== 'production') {
  warnDuplicates(itemsMenu);
}

export default itemsMenu;
